// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3IBWT","box":"WorkspacesBox_box__3aeWv","node":"WorkspacesBox_node__1w9t0"};